var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "d-flex tab-title" },
    [
      _vm.title && _vm.tooltipTargetEl
        ? _c("b-tooltip", {
            key: _vm.tooltipTargetKey,
            attrs: {
              target: _vm.tooltipTargetEl,
              title: _vm.title,
              placement: "left",
              triggers: "hover",
              boundary: "viewport",
              container: "body",
              noninteractive: "",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.icon
        ? [_c("b-icon", { attrs: { icon: _vm.icon } })]
        : [_vm._t("default")],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }